export default "/images/settings.svg?8588567d7abe6a39f8ce830321ab1234";